<template>
  <div class="box">
    <h4 class="title is-6">{{ titleLabel }}</h4>

    <!-- Province -->
    <div class="field">
      <label class="label">{{ provinceLabel }}</label>
      <div class="control">
        <div class="select is-fullwidth">
          <select v-model="selectedProvince">
            <option
              v-for="province in provinceOptions"
              :key="province.value"
              :value="province.value"
            >
              {{ province.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Date -->
    <div class="field">
      <label class="label">{{ dateLabel }}</label>
      <div class="control">
        <input ref="dateInput" class="input" :placeholder="chooseLabel" />
      </div>
    </div>

    <button class="button is-danger is-fullwidth mt-3" @click="applyFilter">
      {{ searchLabel }}
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import flatpickr from "flatpickr";
import { Thai } from "flatpickr/dist/l10n/th.js";

/* Text Label */
const titleLabel = "เงื่อนไขการค้นหา";
const provinceLabel = "จังหวัด";
const searchLabel = "ค้นหา";
const dateLabel = "ระหว่างวันที่";
const chooseLabel = "เลือกช่วงวันที่";

/* options */
const provinceOptions = ref([
  { value: "all", label: "ทั้งหมด" },
  { value: "phitsanulok", label: "พิษณุโลก" },
  { value: "tak", label: "ตาก" },
  { value: "sukhothai", label: "สุโขทัย" },
  { value: "phetchabun", label: "เพชรบูรณ์" },
  { value: "uttaradit", label: "อุตรดิตถ์" },
]);

/* selected values */
const selectedProvince = ref("all");
const selectedDate = ref([]); // range จะได้เป็น array

const applyFilter = () => {
  console.log("Province:", selectedProvince.value);
  console.log("Date Range:", selectedDate.value);
};

const dateInput = ref(null);
let fpInstance = null;

onMounted(() => {
  fpInstance = flatpickr(dateInput.value, {
    mode: "range",

    // 🔹 ค่าที่เก็บจริง (ค.ศ.)
    dateFormat: "Y-m-d",

    // 🔹 เปิด altInput เพื่อใช้แสดงผลอีกตัว
    altInput: true,
    altFormat: "d/m/Y", // โครง format (เราจะ override ปี)

    maxDate: "today",
    locale: Thai,

    // 🔹 แปลงปีตอนแสดงผลเป็น พ.ศ.
    formatDate: (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const yearBE = date.getFullYear() + 543;
      return `${day}/${month}/${yearBE}`;
    },

    // 🔹 เก็บค่าเป็น ค.ศ. (local time ไม่ใช่ UTC)
    onChange: (selectedDates) => {
      selectedDate.value = selectedDates.map((d) => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      });
    },
  });
});

onUnmounted(() => {
  if (fpInstance) fpInstance.destroy();
});
</script>
